import InvestmentReport from './InvestmentReport.js'
class InvestmentCostReport extends InvestmentReport {}
export default InvestmentCostReport
